/* Publish by EComposer at 2026-09-30 08:21:48*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ram1agiemx"]=  window.__ectimmers["ecom-ram1agiemx"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ram1agiemx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ram1agiemx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bdbhldg1bla').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bdbhldg1bla', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4qifds166vw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4qifds166vw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzus08mcjn8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzus08mcjn8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-th52jkp1dd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-th52jkp1dd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-icfypkz33x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-icfypkz33x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-evnkl40p3sl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-evnkl40p3sl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zxsfa4diqeq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zxsfa4diqeq', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7504to2z16x"]=  window.__ectimmers["ecom-7504to2z16x"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-7504to2z16x"]["b8h0iwa9o"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-7504to2z16x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7504to2z16x', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-k8ov4e3kc0b"]=  window.__ectimmers["ecom-k8ov4e3kc0b"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-k8ov4e3kc0b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k8ov4e3kc0b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}